<template>
    <div id="footer">
        <div class="sd-footer">
        <b>{{ $t('bottom[0]') }}</b>
        <i18n path="bottom[1][0]" tag="p">
            <template #learnMore>
                <a :href="`${url}/${urlParam}`" target="_blank" rel="noopener">{{ $t('bottom[1][1]')}}</a>
            </template>
            <template #freeTrial>
                <a :href="freeTrial" target="_blank" rel="noopener">{{ $t('bottom[1][2]')}}</a>
            </template>
        </i18n>
        <div class="copyright-statement">{{ $t('footer[1][0]') }} <a :href="`${urlGeneric}/${termLink}${urlParamJP}`" target="_blank" rel="noopener">{{ $t('footer[1][1]') }}</a> | <a :href="`${urlGeneric}/privacy${urlParamJP}`" target="_blank" rel="noopener" id="cn-more-info">{{ $t('footer[0][2]') }}</a></div>
    </div>
    <!-- Cookie banner was removed when Osano was added, so footer[0][0] and footer[0][1] are no longer used -->
    </div>
</template>
<script>
import consts from '../assets/consts';

export default {
    name: 'Footer',
    data: function() {
        return {
            www: consts.www,
            url: consts.www,
            urlGeneric: consts.www,
            urlParam: consts.linkTracker,
            urlParamJP: consts.linkTracker,
            freeTrial: consts.freeTrial,
            freeTrialEU: consts.freeTrialEU,
            termLink: consts.termLink
        }
    },
    methods: {
        getFreeTrialLink: function(){
            var params = this.$route.query;
            var domainEU = location.host.indexOf('.eu') > -1;
            if ((params !== '' && 'region' in params && params.region === 'eu') || domainEU) {
                this.freeTrial = this.freeTrialEU
            }
        },
        localeLink: function() {
            if (`${this.$router.currentRoute.params.lang}` === 'en') {
                this.url = `${this.www}`
                this.urlGeneric = `${this.www}`
                this.urlParamJP = this.urlParam
            } else if (`${this.$router.currentRoute.params.lang}` === 'ja') {
                this.url = 'https://www.splashtop.co.jp'
                this.urlGeneric = `${this.www}`
                this.urlParamJP = '?sos=1&page=ja'
            } else {
                this.url = `${this.www}/${this.$router.currentRoute.params.lang}`
                this.urlGeneric = `${this.www}/${this.$router.currentRoute.params.lang}`
                this.urlParamJP = this.urlParam
            }
        }
    },
    created: function() {
        this.getFreeTrialLink();
        this.localeLink()
    },
    watch: {
        $route() {
            this.localeLink()
        }
    }
}
</script>